// @<COPYRIGHT>@
// ==================================================
// Copyright 2026.
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@
// @ts-nocheck

/**
 * @module js/DesFileUploadSampleService
 */
import AwPromiseService from 'js/awPromiseService';
import AccFileUploadService from 'js/accFileUploadService';
const desFileUploadSampleService = {};

/**
 *
 * @param {*} parameters
 * @param {*} pendingStatus
 * @returns
 */
desFileUploadSampleService.getSelectedFileInfo = (parameters) => {
    const deferred = AwPromiseService.instance.defer();
    const filesInfo = parameters.formData.map((file) => {
        return { fileName: file.selectedFile }
    });
    const data = {
        dataToBeRelated: {
            attachFiles: parameters.fileName,
            fileInputForms: parameters.formData,
            stageAreaFileInfo: filesInfo
        },
        fileInputForms: parameters.formData
    };
    deferred.resolve(data);
    return deferred.promise;
};

desFileUploadSampleService.uploadFiles = async (accsessionId, files, stageAreaFileInfo, maxChunkSize, concurrencyLimit, endpointConfig) => {
    const deferred = AwPromiseService.instance.defer();
    try {
        // Append upload ticket to file info for each file to be uploaded
        for (const result of stageAreaFileInfo) {
            for (const fileEle of files) {
                if (fileEle.file.name === result?.data?.fileName) {
                    fileEle.file.uploadTicket = result?.data?.uploadTicket;
                }
            }
        }
        console.log('files after setting upload ticket: ', files);
        // Ensure resource must be free
        await AccFileUploadService.uploadFiles(accsessionId, files, maxChunkSize, concurrencyLimit, endpointConfig);
        deferred.resolve(true);
    } catch (err) {
        deferred.reject(err);
    }
    return deferred.promise;
}

desFileUploadSampleService.getNextStep = function( steps ) {
    var currentStep;
    var previousStep = _.find( steps, function( aStep ) {
        if( aStep.isCurrentActive ) {
            return true;
        }
    } );
    _.forEach( steps, function( step, index ) {
        if( step.isCurrentActive ) {
            if( steps[ index + 1 ] ) {
                currentStep = steps[ index + 1 ];
            } else {
                currentStep = steps[ 0 ];
            }
        }
    } );
    return {
        currentStep: currentStep,
        previousStep: previousStep
    };
};

desFileUploadSampleService.stepClickedMethod = function( steps, selectedStep ) {
    return {
        steps: steps,
        currentStep: selectedStep
    };
};

desFileUploadSampleService.toggleUploadingFlag = function(isUploading) {
    return {
        isUploading: isUploading
    }
}
export default desFileUploadSampleService;
